import {
  EltType,
  getNewEltVersionData,
  IELTData,
  IPartnerGroupAdditionalInfo,
  saveEltDocument,
} from 'legacy/lut/components/widgets/public/partner360/ELT'

import { IFinancialCockpitEltDocument } from '../../../api/types'
import { mapSavedEltDocumentToCockpitShape } from '../mapSavedEltDocumentToCockpitShape'

const DEFAULT_PARTNER_GROUP_INFO: IPartnerGroupAdditionalInfo = {
  membersCount: 0,
  partnerId: null,
  groupName: null,
  groupId: null,
}

export interface ICreateEltDocumentArgs {
  partnerId: string
  fYear: number
  fQuarter: number
  eltType: EltType
  versionName: string
  versionSerialNumber: number
  userEmail: string
}

export const createEltDocument = async ({
  partnerId,
  fYear,
  fQuarter,
  eltType,
  versionName,
  versionSerialNumber,
  userEmail,
}: ICreateEltDocumentArgs): Promise<IFinancialCockpitEltDocument> => {
  const { item, formData } = await getNewEltVersionData({
    partnerGroupInfo: DEFAULT_PARTNER_GROUP_INFO,
    versionName,
    versionSerialNumber,
    partnerId,
    fYear,
    fQuarter,
    eltType,
  })

  const [savedFields] = (await saveEltDocument({
    data: item,
    formData,
    additionalData: {},
    userEmail,
  })) as IELTData[]

  return mapSavedEltDocumentToCockpitShape({ ...item, ...savedFields })
}
